<template>
  <div>
    <div v-if="isBonusBallTitle" class="ball-numbers__retail-title">BONUS BALL</div>
    <div class="ball-numbers ball-numbers__retail">
      <div
          v-if="isZeroNumber"
          class="ball-numbers__item__container"
      >
        <a
            :tabindex='0'
            :class="{active: resultsNumberAdditional.includes(0), disable:numberDisable.find((e) => e.number === 0)?.disable}"
            :ref="setItemRef"
            class="ball-numbers__item focusable first-number"
            @click="selectItem($event, 0)"
            @keydown.space.prevent="selectItem($event, 0)"
            @keydown.tab.prevent="handleTabNextSection()"
        >
          <span>0</span>
        </a>
      </div>
      <div class="ball-numbers__item__container" v-for="(item, index) in numbers"
           :key="index"
      >
        <a
            :tabindex='index'
            v-if="!isBonusBallTitle && item >= minPicks"
            :class="{active: resultsNumberMain.includes(item), disable:numberDisable.find((e) => e.number === item)?.disable}"
            :ref="setItemRef"
            class="ball-numbers__item focusable first-number"
            @click="selectItem($event, item)"
            @keydown.space.prevent="selectItem($event, item)"
            @keydown.tab.prevent="handleTabNextSection()"
        >
          <span>{{ item }}</span>
        </a>
        <a
            :tabindex='index'
            :class="{active: resultsNumberAdditional.includes(item), disable:numberDisable.find((e) => e.number === item)?.disable}"
            v-if="isBonusBallTitle && item >= minPicks"
            class="ball-numbers__item focusable first-number"
            @click="selectItem($event, item)"
            @keydown.tab.prevent="handleTabNextSection()"
            @keydown.space.prevent="selectItem($event, item)"
        >
          <span>{{ item }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numbers: {
      type: Array,
      default: () => []
    },
    resultsNumberMain: {
      type: Array,
      default: () => []
    },
    resultsNumberAdditional: {
      type: Array,
      default: () => []
    },
    isBonusBallTitle: {
      type: Boolean,
      default: false
    },
    isFocusNumber: {
      type: Boolean,
      default: false
    },
    maxPicks: {
      type: Boolean,
      default: false
    },
    numbersPicked: {
      type: Array,
      default: () => []
    },
    maxPicksLength: {
      type: Number,
      default: 0
    },
    minPicks: {
      type: Number,
      default: 0
    },
    isZeroNumber: {
      type: Boolean,
      default: false
    },
    numberDisable: {
      type: Array,
       default: () => []
    }
  },
  data() {
    return {
      itemRefs: []
    }
  },
  beforeUpdate() {
    this.itemRefs = [];
  },
  updated() {
    if(!this.isBonusBallTitle) {
      // this.itemRefs[0].focus();
    }
  },
  watch: {
    isFocusNumber(data, data2) {
      if(!this.isBonusBallTitle) {
        this.itemRefs[0].focus();
      }
    }
  },
  methods: {
    handleTabNextSection() {
      this.$emit('tabNumbers');
    },
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el)
      }
    },
    selectItem($event, item) {
      if(this.numbersPicked.includes(item) || this.numbersPicked.length < this.maxPicksLength) {
        this.$emit('selectItem', item);
        // $event.target.classList.toggle('active');
        $event.preventDefault();
      }
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/ball/ball-numbers.scss"/>
